import React, { useState } from "react";
import {
  Sparkles,
  Brush,
  Scissors,
  Droplets,
  Hand,
  PenTool,
  UtensilsCrossed,
  ShoppingBag,
  Music3,
  Dumbbell,
  Dog,
  Car,
  CheckCircle,
  Tent,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import ProcessingBar2 from "../../../components/ProcessingBar/ProcessingBar2";

const categories = [
  { label: "Beauty", icon: <Sparkles size={28} className="text-redlight" /> },
  { label: "Nails", icon: <Brush size={28} className="text-redlight" /> },
  { label: "Barbers", icon: <Scissors size={28} className="text-redlight" /> },
  {
    label: "Spa & sauna",
    icon: <Droplets size={28} className="text-redlight" />,
  },
  { label: "Massages", icon: <Hand size={28} className="text-redlight" /> },
  { label: "Tattoo", icon: <PenTool size={28} className="text-redlight" /> },
  {
    label: "Restaurants",
    icon: <UtensilsCrossed size={28} className="text-redlight" />,
  },
  {
    label: "Take a way",
    icon: <ShoppingBag size={28} className="text-redlight" />,
  },
  { label: "Night Market", icon: <Tent size={28} className="text-redlight" /> },
  { label: "Gym", icon: <Dumbbell size={28} className="text-redlight" /> },
  { label: "Pet care", icon: <Dog size={28} className="text-redlight" /> },
  { label: "Car wash", icon: <Car size={28} className="text-redlight" /> },
];

const CourseCategory = () => {
  const [selected, setSelected] = useState(null);
  const [processingLabel, setProcessingLabel] = useState(null);
  const navigate = useNavigate();

  const handleSelect = (label) => {
    if (processingLabel) return; // lock others during processing
    setSelected(label);

    // Step 1: show check briefly
    setTimeout(() => {
      setProcessingLabel(label); // show processing in selected box
    }, 1000);

    // Step 2: navigate after delay
    setTimeout(() => {
      navigate("/register");
    }, 4000);
  };

  return (
    <>
      {categories.map((item, idx) => {
        const isSelected = selected === item.label;
        const isProcessing = processingLabel === item.label;
        const isDisabled = Boolean(processingLabel); // disable all during processing

        return (
          <div className="w-1/3 sm:w-1/3 lg:w-1/6 px-2 mb-6" key={idx}>
            <div
              onClick={() => {
                if (!isDisabled) handleSelect(item.label);
              }}
              className={`group flex flex-col items-center justify-center border rounded-md p-6 text-center transition
                ${
                  isSelected
                    ? "border-redlight bg-redlightlight"
                    : "border-drylight bg-dry"
                }
                ${
                  isDisabled
                    ? "opacity-50 cursor-not-allowed"
                    : "cursor-pointer hover:border-redlight hover:bg-redlightlight"
                }`}
            >
              {/* Initial check + label + icon */}
              <div className="min-h-[70px] flex flex-col items-center justify-center">
                {isSelected && !isProcessing && (
                  <>
                    <div className="mb-4">{item.icon}</div>
                    <div className="text-sm font-medium text-dry flex items-center">
                      <CheckCircle size={18} className="mr-2 text-dry" />
                      {item.label}
                    </div>
                  </>
                )}

                {isProcessing && <ProcessingBar2 />}

                {!isSelected && (
                  <>
                    <div className="mb-4">{item.icon}</div>
                    <div className="text-sm font-medium text-text">
                      {item.label}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

const CourseCategorySection = () => {
  return (
    <section className="pt-24 pb-12 lg:pt-24 bg-black">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16" data-aos="fade-up">
          <p className="uppercase text-sm tracking-widest text-redlight mb-2">
            OUR CATEGORIES
          </p>
          <h2 className="text-3xl md:text-4xl font-medium mb-2 text-text px-3">
            Pick a business type to get started for free
          </h2>
        </div>
        <div className="flex flex-wrap justify-center -mx-2">
          <CourseCategory />
        </div>
      </div>
    </section>
  );
};

export default CourseCategorySection;
